import { Select } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { RtCtrlData, RtCtrlSelectionRows } from "../ctrl";
import { AbstractRow, RtKey } from "../RtTypes";

type PropsRtSelection<TRow extends AbstractRow> = {
  store: RtCtrlData<TRow> & RtCtrlSelectionRows<TRow>;
  makeOption: (
    key: RtKey,
    row?: TRow,
  ) => { value: RtKey; label: React.ReactNode };
  emptyMsg?: React.ReactNode;
};

export const RtSelection = observer(
  <TRow extends AbstractRow>(
    props: PropsRtSelection<TRow>,
  ): React.ReactNode => {
    const { store, makeOption, emptyMsg } = props;
    const { selectedRows, selectedKeys } = store;
    return (
      <Select
        mode="multiple"
        maxTagCount="responsive"
        value={selectedKeys}
        options={selectedKeys.map((key) =>
          makeOption(
            key,
            selectedRows.find((row) => store.getRowKey(row) === key),
          ),
        )}
        onChange={(keys) => store.setSelectedKeys(keys)}
        disabled={selectedKeys.length === 0}
        placeholder={emptyMsg ?? "Ничего не выбрано"}
        allowClear
        style={{ width: "100%" }}
      />
    );
  },
);
